<div class="core-part-container flex-column flex-start">
  <div class="core-part-header border-bottom-lightest flex-row flex-start ui-g w-100">
    <div class="flex-start-center p-2 mb-1 ui-g-12">
      <p class="m-0 font-600 ui-g-2">Item name</p>
      <p class="m-0 font-600 ui-g-2">Description</p>
      <p class="m-0 font-600 ui-g-1 text-right">Cost</p>
      <p class="m-0 font-600 ui-g-1 text-right">Core</p>
      <p class="m-0 font-600 ui-g-1 text-right">Qty</p>
      <p class="m-0 font-600 ui-g-1 text-right">Total&nbsp;cost</p>
      <p class="m-0 font-600 ui-g-2">Service</p>
      <p class="m-0 font-600 ui-g-2">Status</p>
    </div>
  </div>

  <div class="core-part-body flex-row flex-start ui-g w-100">
    <div *ngFor="let item of orderWithCoreItems?.itemsWithCore; let last = last; let index = index;" class="flex-start-start p-2 ui-g-12"
      [ngClass]="{'border-bottom-lightest': !last}">
      <p class="m-0 font-13 font-400 ui-g-2">{{item.title}}</p>
      <p class="m-0 font-13 font-400 ui-g-2 word-break description">{{item.description}}</p>
      <p class="m-0 font-13 font-400 ui-g-1 text-right">{{item.cost || 0 | currency: usd}}</p>
      <p class="m-0 font-13 font-400 ui-g-1 text-right">{{item.coreCost || 0| currency: usd}}</p>
      <p class="m-0 font-13 font-400 ui-g-1 text-right">{{item.count || 0 | number: '1.2-2'}}</p>
      <p class="m-0 font-13 font-400 ui-g-1 text-right">{{item.coreCost || 0| currency: usd}}</p>
      <p class="m-0 font-13 font-400 ui-g-2">{{item.serviceTitle}}</p>
      <div class="m-0 font-13 font-400 ui-g-2">
        <app-dropdown id="core-part-status-{{index}}" listId="core-part-type-list-{{index}}" theme="primary"
          styleClass="pl-0" styleClassSelectedView="pl-0" styleClassLabel="left-0" itemWidth="150px"
          [isDropdownIconVisible]="true" [disabled]="false" [floatingLabel]="true" [listItemFontSize]="13"
          [fontSize]="13" [value]="item._coreRetrievalStatus" [options]="coreStatusOptions"
          (appSelect)="selectCoreStatus(item, $event?.value)"></app-dropdown>
      </div>
    </div>
  </div>
</div>
